import React, { useContext } from "react";
import { Row } from "reactstrap";
import CommonButton from "../../Utils/CommonButton";
import { CreateOfferContext } from "./context";
import { useNavigate } from "react-router-dom";

const AddOfferFooter = () => {
  const navigate = useNavigate();
  const {
    activeMainTab,
    setActiveMainTab,
    touched,
    setTouched,
    errors,
    isEdit,
  } = useContext(CreateOfferContext);

  const markAllTouched = (errors) => {
    if (Array.isArray(errors)) {
      return errors.map((item) => markAllTouched(item));
    }

    if (typeof errors === "object" && errors !== null) {
      return Object.keys(errors).reduce((acc, key) => {
        acc[key] = markAllTouched(errors[key]);
        return acc;
      }, {});
    }

    return true;
  };

  const handleNext = async () => {
    const obj = {
      offerName: true,
      offerCode: true,
      offerPriority: true,
      subscriptionStartsOn: true,
      timePeriodStart: true,
      timePeriodOptionStart: {
        value: true,
        label: true,
      },
      subscriptionEndsOn: true,
      timePeriod: true,
      timePeriodOption: {
        value: true,
        label: true,
      },
      description: true,
      offerStartsOn: true,
      offerEndsOn: true,
      usageId: true,
      eventType: true,
      resourceName: true,
      unitOfMeasurement: true,
      priority: true,
      perUnitRate: true,
      flatRate: true,
      serviceName: true,
      policyName: true,
      aggregateVolume: [],
      usageRatePlan: [],
      recurringUsageRatePlan: [],
      grants: [],
      recurringGrants: [],
      charges: [],
      recurringCharges: [],
      effectiveAt: true,
      pricingModel: [],
      categories: true,
      ...errors,
    };

    await setTouched(markAllTouched(obj), true);

    if (
      (Object.keys(touched).length > 0 && Object.keys(errors).length === 0) ||
      isEdit
    ) {
      setActiveMainTab((prev) => prev + 1);
    }
  };

  return (
    <Row className="px-3 pt-4">
      <div className="d-flex justify-content-between gap-2 flex-wrap">
        <div className="d-flex gap-2 ms-auto">
          <CommonButton
            outline={true}
            className={
              "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            }
            color={"main-color"}
            type={"reset"}
            buttonAction={() => navigate("/offer")}
            buttonText={"Cancel"}
            icon={
              <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
            }
            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
          />
          {activeMainTab < 4 && (
            <CommonButton
              color={"main-color"}
              className={
                "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              }
              icon={
                <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
              }
              btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              type={"button"}
              buttonAction={handleNext}
              buttonText={"Next"}
            />
          )}
          <CommonButton
            color={"main-color"}
            className={
              "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            }
            icon={
              <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
            }
            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
            type={"submit"}
            buttonText={"Submit"}
          />
        </div>
      </div>
    </Row>
  );
};

export default AddOfferFooter;
